import React from 'react';
import Spinner from 'react-spinkit';
import { useTheme } from '@material-ui/core/styles';

const CategoryLoading = () => {
  const theme = useTheme();
  return (
    <div>
      <Spinner name="circle" color={theme.palette.primary.main} />
    </div>
  );
};

export default CategoryLoading;
